
import List from './list/index.vue';
import Detail from './detail/index.vue';
export default [
  {
    path: 'list',
    name: 'trusteeshipList',
    component: List,
    meta: {
      title: '托管列表',
      breadCrumbShowIndexArr: [0, 2]
    }
  },
  {
    path: 'detail',
    name: 'trusteeshipDetail',
    component: Detail,
    meta: {
      title: '托管详情',
      breadCrumbShowIndexArr: [0, 2]
    }
  }
];
